import React from 'react';
import { Modal, Spin, Input, message, Form, Select, Row, Col} from 'antd';
import { addTemplate } from '../../../services/ReportTemplateService';
import { 
  useReportTemplate, 
  ReportTreeRenderer, 
  buildColumnMapping 
} from './templateUtils';

const CreateReportTemplate = ({ type_name, iec_no, visible, onClose, onSubmit }) => {
  const [form] = Form.useForm();
  
  const {
    loading,
    treeData,
    checkedColumns,
    filters,
    existingTemplates,
    onColumnReorder,
    onCheck,
    onFilterChange,
    onOrderChange,
    onTemplateSelect,
    resetState,
    validateFilters
  } = useReportTemplate({
    type_name,
    visible,
    templateId: null // This indicates create mode vs edit mode
  });

  const handleClose = () => {
    resetState();
    form.resetFields();
    onClose();
  };

  const handleSaveTemplate = async () => {
    try {
      const values = await form.validateFields();

      const errors = validateFilters();
        if (errors.length > 0) {
          message.error(errors.join('\n'));
          return;
        }
      
      const payload = {
        template_name: values.templateName,
        description: values.description,
        type_name: type_name,
        column_mapping: buildColumnMapping(checkedColumns),
        col_filters: filters
      };

      const res = await addTemplate(payload);
      
      if (res.status === 200) {
        message.success("Template created successfully!");
        if (onSubmit) onSubmit();
        handleClose();
      } else {
        message.error(res.msg || "Failed to create template");
      }
    } catch (err) {
      console.error("Validation Failed:", err);
    }
  };


  return (
    <Modal
      title={`Create ${type_name} Template`}
      open={visible}
      onCancel={handleClose}
      onOk={handleSaveTemplate}
      width={1000}
    >
      <Form form={form} layout="vertical">
      <Row gutter={16}>
      <Col span={12}>
        <Form.Item 
          label="Template Name" 
          name="templateName" 
          rules={[{ required: true, message: 'Please enter template name' }]}
        >
          <Input
            placeholder="Enter template name"
            allowClear
          />
        </Form.Item>
        </Col>
        <Col span={12}>
        <Form.Item 
          label="Description" 
          name="description" 
          rules={[{ required: false }]}
        >
          <Input 
            placeholder="Enter description"
            allowClear
          />
        </Form.Item>
        </Col>
        </Row>
        <Form.Item label="Select From Existing Template">
          <Select
            placeholder="Select template"
            allowClear
            onChange={(value) => onTemplateSelect(value)}
          >
            {existingTemplates.map((template) => (
              <Select.Option key={template.id} value={template.id}>
                {template.template_name}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>
      </Form>
      
      {loading ? (
        <Spin />
      ) : (
        <ReportTreeRenderer
          treeData={treeData}
          checkedColumns={checkedColumns}
          onCheck={onCheck}
          filters={filters}
          onOrderChange={onOrderChange}
          onColumnReorder={onColumnReorder}
          onFilterChange={onFilterChange}
          disabled={false}
          showOrderControls={true}
          billType={type_name}
        />
      )}
    </Modal>
  );
};

export default CreateReportTemplate;